import { BaseServices, HttpMethod } from '@services/base'

export default async (accessToken?: string) => {
  const pathname = process.env.REACT_APP_GET_CAPTURE_DOCUMENTS
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  }

  const response = await BaseServices.request<CapturaDocumentoRequest>({
    headers,
    pathname,
    method,
    host,
  })
  return response
}

export interface CapturaDocumentoRequest {
  idInteracao: string
  numeroProposta: string
  pendentes: unknown[]
  enviados: unknown[]
}
